import { GIANT_ORDER_COUNT, type MissionRef } from './mission';
import type { GiantId } from '../ids/ids';
import { GIANT_IDS } from '../ids/ids';

export type GiantOrderDef = {
  readonly title: string;
  readonly riddle: string;
  readonly item: string;
  readonly answer: string;
};

/**
 * Заказы по гигантам (канон из v1 `giantOrders`, id v3).
 * Порядок и количество совпадают с {@link GIANT_ORDER_COUNT}.
 */
export const GIANT_ORDERS = {
  svami: [
    {
      title: 'Спиночесалка',
      riddle: 'Доставьте мне что-нибудь, чем можно почесать спину!',
      item: 'Строительный кран',
      answer: 'Строительный кран! Он так приятно чешет кирпичики.',
    },
    {
      title: 'Листва пожухла',
      riddle: 'Срочно! Моя Листва совсем пожухла! Сделайте что-нибудь!',
      item: 'Банка зелёной краски',
      answer: 'Спасибо! Просто крышесносный оттенок!',
    },
    {
      title: 'Украшение для листвы',
      riddle: 'Доставьте мне какое-нибудь украшение для листвы',
      item: 'Гнездо с аистом',
      answer: 'Спасибо, смотрится очень живо',
    },
  ],
  roza: [
    {
      title: 'Большая медведица',
      riddle: 'Срочно! Найдите мне большую медведицу!',
      item: 'Маленький медвежонок',
      answer: 'Хмм… Какая-то это медведица небольшая',
    },
    {
      title: 'Милота',
      riddle: 'Так хочется милоты в этот скучный вечер!',
      item: 'Фотки с котиками',
      answer: 'Шикарно!',
    },
    {
      title: 'Давненько не видела книги',
      riddle: 'Давненько я не видела интересной книги!',
      item: 'Очки',
      answer: 'Теперь вижу, но книги всё ещё ерунда…',
    },
  ],
  drakochi: [
    {
      title: 'Острый перекус',
      riddle: 'Доставьте мне чего-нибудь остренького для перекуса!',
      item: 'Кактус',
      answer: 'Ай! Вкусно! Ай! Ой! Остренько',
    },
    {
      title: 'Что-то крутое',
      riddle: 'Время доставки чего-то крутого!!!',
      item: 'Яйцо',
      answer: 'Яйцо всмятку — самое крутое!',
    },
    {
      title: 'Новый звук',
      riddle: 'Доставьте мне новый звук',
      item: 'Орущая резиновая курица',
      answer: 'Теперь это солист моей группы!',
    },
  ],
  yetti: [
    {
      title: 'Песня для вдохновения',
      riddle: 'Доставьте мне свежую песню для вдохновения!',
      item: 'Пластинка с изображением Лайк (релизнутый трек)',
      answer: 'Хм… Качает… (Поёт) Крошки, я вас вижу…',
    },
    {
      title: 'Трогательное',
      riddle: 'Доставьте мне чего-нибудь трогательного',
      item: 'Крапива',
      answer: 'Ой... Крапиву лучше не трогать…',
    },
    {
      title: 'След в истории',
      riddle: 'Мне нужно срочно оставить след в истории!',
      item: 'Фотоаппарат',
      answer: 'Ура, пойду сфотографирую свои следы',
    },
  ],
  mona: [
    {
      title: 'Прыгучие дельфины',
      riddle: 'Мои дельфины слишком распрыгались. Сделайте с этим что-нибудь!',
      item: 'Скакалка',
      answer: 'Хм… Скакалка для дельфинов? Ну пусть хотя бы прыгают с пользой!',
    },
    {
      title: 'Страшное чтение',
      riddle: 'Хочу почитать что-нибудь страшное!',
      item: 'Школьный дневник',
      answer: 'Мой школьный дневник??? Какой кошмар…',
    },
    {
      title: 'Игра на нервах',
      riddle: 'Мои дельфины играют у меня на нервах!',
      item: 'Скрипка',
      answer: 'Спасибо, теперь не слышно как я ругаюсь',
    },
  ],
  duck: [
    {
      title: 'Спасательный круг',
      riddle: 'Полууундра! Срочно нужен спасательный круг!',
      item: 'Пончик',
      answer: 'О, вы меня спасли! Пончик — это даже лучше, чем спасательный круг!',
    },
    {
      title: 'Пассажиры зажигают',
      riddle: 'Помогите. Пассажиры зажигают на моём борту!',
      item: 'Огнетушитель',
      answer: 'Не помогло, теперь у них Пенная вечеринка!',
    },
    {
      title: 'Костюм для маскарада',
      riddle: 'УУ! Нужен костюм для маскарада!',
      item: 'Курочка',
      answer:
        'Ха-ха! Никто не догадается, что Капитан Курочка и Капитан Уточка — это одно лицо!',
    },
  ],
  serj: [
    {
      title: 'Ик… Икота',
      riddle: 'Ик… Ик… Мне нужно средство от икоты… Ик!',
      item: 'Дельфин на пружинке',
      answer: 'Ааааааа! Возмутительно! Но… икота ушла, спасибо.',
    },
    {
      title: 'Рифма к «пюре»',
      riddle: 'Срочно доставьте мне рифму к слову «пюре»!',
      item: 'Котлета',
      answer: 'Пюре с котлетой идеально рифмуются!',
    },
    {
      title: 'Не спится',
      riddle: 'Мне совсем не спится! Помогите!',
      item: 'Овечки',
      answer: 'Раз овечка, два овечка… Хррр',
    },
  ],
  factor: [
    {
      title: 'Разобраться в себе',
      riddle: 'Мне нужно что-нибудь, чтобы разобраться в себе',
      item: 'Гаечный ключ',
      answer: 'О, гаечный ключ? То, что нужно, чтобы разобраться в себе!',
    },
    {
      title: 'Новая батарея',
      riddle: 'У меня разрядилась батарея — принесите мне новую',
      item: 'Отопительная батарея',
      answer: 'Спасибо, а то в пустыне было слишком холодно.',
    },
    {
      title: 'Выпустить пар',
      riddle: 'Мне срочно нужно что-нибудь, чтобы выпустить пар!',
      item: 'Чайник',
      answer: 'Хм, чайник действительно выпускает пар',
    },
  ],
  willy: [
    {
      title: 'Что-нибудь для памяти',
      riddle: 'Доставьте мне что-нибудь для улучшения памяти!',
      item: 'Валенки',
      answer: 'Не помню, чтобы я что-то заказывал, но спасибо…',
    },
    {
      title: 'Расческа для усов',
      riddle: 'Доставка! Срочно что-то для расчесывания усов!',
      item: 'Грабли',
      answer: 'И завитушечки сделаю. Благодарю!',
    },
    {
      title: 'Согреть вулкан',
      riddle: 'Брр, я замерз! Принесите что-нибудь согревающее',
      item: 'Носки',
      answer: 'Эмм... Спасибо. На чтобы их надеть Старому вулкану?',
    },
  ],
  sol: [
    {
      title: 'ЯРКОЕ',
      riddle: 'Доставьте мне что-нибудь яркое!',
      item: 'Зеркало',
      answer: 'Ой, кто это в зеркале? Воу-воу! Слишком ЯРКО!',
    },
    {
      title: 'Бессонница',
      riddle: 'Не могу уснуть! Помогите!',
      item: 'Луна Му',
      answer: 'О, уже ночь, пора спать!',
    },
    {
      title: 'Самозащита',
      riddle: 'Доставьте мне что-нибудь для самозащиты',
      item: 'Крем от солнца',
      answer: 'Всем нужен крем от солнца',
    },
  ],
  mu: [
    {
      title: 'Что-нибудь на «Му»',
      riddle: 'Доставьте мне что-нибудь на «Му».',
      item: 'Корова (с баблом «Му»)',
      answer: 'Хм… спасибо, правда корова на «Ко», а не на «Му»',
    },
    {
      title: 'Музыкальная еда',
      riddle: 'Принесите мне музыкальной еды!',
      item: 'Фасоль',
      answer: 'Фа и Соль, очень музыкально',
    },
    {
      title: 'Вспомнить молодость',
      riddle: 'Хочется вспомнить молодость',
      item: 'Фото растущего месяца',
      answer: 'Я была такой молодой луной!',
    },
  ],
} as const satisfies Record<GiantId, readonly GiantOrderDef[]>;

function assertOrdersAlignWithDomain(): void {
  for (const giantId of GIANT_IDS) {
    const n = GIANT_ORDERS[giantId].length;
    const expected = GIANT_ORDER_COUNT[giantId];
    if (n !== expected) {
      throw new Error(
        `GIANT_ORDERS[${giantId}] has ${n} entries, GIANT_ORDER_COUNT expects ${expected}`,
      );
    }
  }
}

assertOrdersAlignWithDomain();

export function getGiantOrder(mission: MissionRef): GiantOrderDef {
  const orders = GIANT_ORDERS[mission.giantId];
  if (orders == null) {
    throw new Error(`getGiantOrder: unknown giantId "${String(mission.giantId)}"`);
  }
  const order = orders[mission.orderIndex];
  if (order == null) {
    throw new Error(
      `getGiantOrder: orderIndex ${String(mission.orderIndex)} out of range for "${mission.giantId}"`,
    );
  }
  return order;
}

export function getGiantOrderRiddle(mission: MissionRef): string {
  return getGiantOrder(mission).riddle;
}

export function getGiantOrderItem(mission: MissionRef): string {
  return getGiantOrder(mission).item;
}

export function getGiantOrderAnswer(mission: MissionRef): string {
  return getGiantOrder(mission).answer;
}

/** Название заказа для UI (кавычки как в макете new_delivery). */
export function formatGiantOrderLevelName(title: string): string {
  return `\u201c${title}\u201d`;
}
